export default __webpack_public_path__ + "static/media/testimonial-1.17fff8a3.jpg";